module.exports = __webpack_public_path__ + "img/index-simple-step1.b5dd9237.png";